import { useTranslation } from "react-i18next";
import Faq from "../shared/Faq";
import LandingFooter from "../shared/LandingFooter";
import LandingNav, { type NavLink } from "../shared/LandingNav";
import type { LandingData } from "../types";
import Bento from "./Bento";
import HeroB from "./HeroB";
import PlansB from "./PlansB";
import StoriesStrip from "./StoriesStrip";
import Wordmark from "./Wordmark";

// Keyframes for the CSS-only effects (hero entrance, lock pop); Tailwind's config is shared, so they live with the page that uses them.
const CSS = `@keyframes b-rise{from{opacity:0;transform:translateY(18px)}}@keyframes b-pop{50%{transform:scale(1.08)}}
`;

// Cobalt Paper: light editorial landing with automatic dark mode. No WebGL, so it is the lightest of the three.
export default function LandingB({ data }: { data: LandingData }) {
  const { t } = useTranslation();
  const links: NavLink[] = [
    { href: "#features", label: t("ui.landing.nav.features") },
    { href: "#plans", label: t("ui.landing.nav.plans") },
    { href: "#faq", label: t("ui.landing.nav.faq") },
  ];
  return (
    <div className="min-h-[100dvh] overflow-x-clip">
      <style>{CSS}</style>
      <LandingNav data={data} links={links} heroId="hero-cta" />
      <main>
        <HeroB data={data} />
        <Wordmark />
        <Bento />
        <StoriesStrip />
        <PlansB data={data} />
        <Faq variant="editorial" className="pb-[clamp(64px,9vw,128px)]" />
      </main>
      <LandingFooter data={data} />
    </div>
  );
}
